import type { SvgComponent } from '@/types/SvgComponent';

export const BatchViewModeIcon: SvgComponent = ({ ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <g clipPath="url(#clip0_3145_36090)">
        <path
          d="M16.6667 4H4.66667C4.29848 4 4 4.29848 4 4.66667V16.6667C4 17.0349 4.29848 17.3333 4.66667 17.3333H16.6667C17.0349 17.3333 17.3333 17.0349 17.3333 16.6667V4.66667C17.3333 4.29848 17.0349 4 16.6667 4Z"
          stroke="white"
          strokeWidth="0.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M10.666 4V17.3333" stroke="white" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4 10.6667H17.3333" stroke="white" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_3145_36090">
          <rect width="21.3333" height="21.3333" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
